import { fonts } from '@local/web-design-system/dist/styles';
import type { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

const FULL_WIDTH = '100%' as const;
const FIELD_BOTTOM_PAD_FACTOR = 2;

export const useStyles = makeStyles()((theme: Theme) => {
    const fieldGap = theme.spacing(FIELD_BOTTOM_PAD_FACTOR);
    return {
        formContainer: {
            maxWidth: theme.spacing(44.75),
            backgroundColor: theme.palette.grey[200],
            padding: theme.spacing(2),
        },
        formField: {
            width: FULL_WIDTH,
            paddingBottom: fieldGap,
        },
        textField: {
            width: FULL_WIDTH,
        },
        buttonText: {
            fontSize: '14px',
        },
        formButton: {
            ...fonts.button,
            color: theme.palette.primary.contrastText,
            width: FULL_WIDTH,
            height: theme.spacing(5),
            '&:disabled': {
                backgroundColor: theme.palette.grey[400],
                color: theme.palette.common.white,
                opacity: 0.8,
            },
        },
        disabledButton: {
            ...fonts.button,
            color: 'black !important',
            backgroundColor: `${theme.palette.grey[500]} !important`,
            width: FULL_WIDTH,
            height: theme.spacing(5),
        },
        subscriptionMessage: {
            width: FULL_WIDTH,
            paddingBottom: fieldGap,
        },
        imagoIdErrorMessage: {
            width: FULL_WIDTH,
            paddingBottom: fieldGap,
            color: theme.palette.error.main,
        },
    };
});
